export interface ICustomerContactDto {
    name?: string
    telephone?: string
    email?: string
}

export interface ICustomerContact {
    name?: string
    telephone?: string
    email?: string
}

export default class CustomerContact implements ICustomerContact {
    name?: string
    telephone?: string
    email?: string

    constructor(dto: ICustomerContactDto) {
        this.name = dto.name
        this.telephone = dto.telephone
        this.email = dto.email
    }

    toDto() {
        return {
            name: this.name,
            telephone: this.telephone,
            email: this.email,
        }
    }
}
